import { createFileRoute } from '@tanstack/react-router';
import { MagicLink } from '@/pages';

/**
 * Invite landing — the screen a creator sees after clicking a magic link.
 */
export const Route = createFileRoute('/_public/invite/')({
  component: MagicLink,
});
